/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationResourceListModel {
    getFixupPrototypeFunction() { return OperationResourceListModel.fixupPrototype; }

    static newInstance(model: Partial<OperationResourceListModel>): OperationResourceListModel {
        let obj = Object.assign(new OperationResourceListModel(), model);
        OperationResourceListModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationResourceListModel>): OperationResourceListModel {
        if (!model) return null;
        return OperationResourceListModel.newInstance(<OperationResourceListModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationResourceListModel) {
        if (!obj) return;

        models.OperationResourceListModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationResourceListModel): boolean {
        Object.setPrototypeOf(obj, OperationResourceListModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * cloud account name
     */
    cloud_account_name: string;

    /**
     * cloud account id
     */
    cloud_account_id: string;

    /**
     * Name of the tenant
     */
    tenant_name: string;

    /**
     * Id of the tenant
     */
    tenant_id: string;

    /**
     * user name
     */
    username: string;

    /**
     * alert type
     */
    alert_type: string;

    /**
     * event data id
     */
    eventDataId: string;

    /**
     * resource_name
     */
    resource_name: string;

    /**
     * region name
     */
    region: string;

    /**
     * resource_group name
     */
    resource_group: string;

    /**
     * zone name
     */
    zone: string;

    /**
     * location name
     */
    location: string;

    /**
     * resource id name
     */
    resourceId: string;

    /**
     * resource group id name
     */
    resourceGroupId: string;

    /**
     * status
     */
    status: string;

    /**
     * description
     */
    description: string;

    /**
     * resource
     */
    resource: string;

    /**
     * event_action
     */
    event_action: any;

    /**
     * resource_type name
     */
    resource_type: string;

    /**
     * event creation time (UTC)
     */
    event_creation_time: string;

    /**
     * metric name
     */
    metric_name: string;

    /**
     * metric value
     */
    metric_value: string;

    /**
     * threshold
     */
    threshold: string;

    /**
     * operator
     */
    operator: string;

    /**
     * windowSize
     */
    windowSize: string;

    /**
     * snooze
     */
    snooze: string;

    /**
     * analysis
     */
    analysis: string;

    /**
     * action
     */
    action: Array<string>;

    /**
     * cloud name
     */
    cloud: string;

    /**
     * job type
     */
    job_type: string;

    /**
     * Id of template
     */
    template_id: string;

    /**
     * Id of blueprint
     */
    blueprint_id: string;

}
